// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
import React, { useEffect, useRef } from "react";
import { Loader2 } from "lucide-react";
import { API } from "../lib/api";
import { useApp } from "../context/AppContext";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";

const AuthCallback = () => {
  const { refreshCurrentUser } = useApp();
  const navigate = useNavigate();
  const processedRef = useRef(false);

  useEffect(() => {
    if (processedRef.current) return;
    processedRef.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) { navigate("/", { replace: true }); return; }
    const sessionId = decodeURIComponent(match[1]);

    (async () => {
      try {
        const res = await API.post("/auth/emergent-session", null, {
          headers: { "X-Session-ID": sessionId },
        });
        // Clear the fragment then refresh user state
        window.history.replaceState(null, "", window.location.pathname);
        if (refreshCurrentUser) await refreshCurrentUser();
        toast.success(`Selamat datang, ${res.data.user?.name || "Warga"}!`);
        navigate("/", { replace: true });
      } catch (err) {
        const detail = err.response?.data?.detail || err.message;
        toast.error(detail);
        // Clear fragment; go to login so user can try again
        window.history.replaceState(null, "", "/login");
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, refreshCurrentUser]);

  return (
    <div className="min-h-screen grid place-items-center bg-slate-50">
      <div className="text-center">
        <Loader2 className="h-8 w-8 animate-spin text-emerald-600 mx-auto" />
        <div className="mt-3 text-sm text-slate-600">Menyelesaikan proses masuk...</div>
      </div>
    </div>
  );
};
export default AuthCallback;
